import { useEffect } from 'react';

import type { NHeaderProvider } from '@app/providers/HeaderProvider/HeaderProvider.types';

import type { Dispatch, SetStateAction } from 'react';

interface UseSubscriptionsEffectsProps {
  setHeader: Dispatch<SetStateAction<NHeaderProvider.Header>>;
  openCreateModal: () => void;
}

export const useSubscriptionsEffects = ({
  setHeader,
  openCreateModal,
}: UseSubscriptionsEffectsProps): void => {
  useEffect(() => {
    setHeader({ openSubscriptionModal: openCreateModal });
  }, [setHeader, openCreateModal]);
};
